module.exports = __webpack_public_path__ + "img/5.d7f8cbc1.png";